import React from "react";
import { motion } from "framer-motion";
import { FiArrowUpRight, FiHeart } from "react-icons/fi";
import { SiKofi } from "react-icons/si";
import { useLanguage } from "../../i18n/LanguageContext";
import { profile } from "../../data/profile";
import { Reveal } from "../common/Reveal";
import { Icon } from "../common/Icon";
import "./Support.css";

export function Support() {
  const { t } = useLanguage();
  const s = t.support;

  return (
    <section id="support" className="section support">
      <div className="container section-inner">
        <Reveal direction="up">
          <span className="eyebrow">{s.eyebrow}</span>
          <h2 className="section-heading">{s.heading}</h2>
          <p className="section-sub">{s.subheading}</p>
        </Reveal>

        <Reveal direction="up" delay={0.15}>
          <motion.div
            className="support-card"
            whileHover={{ y: -4 }}
            transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          >
            <div className="support-card__glow" aria-hidden="true" />
            <div className="support-card__content">
              <div className="support-card__header">
                <div className="support-card__badge-wrap">
                  <span className="tag support-card__tag">
                    <Icon icon={SiKofi} className="support-card__kofi-icon" /> {s.cardTag}
                  </span>
                  <span className="support-card__verified mono">
                    <span className="support-card__verified-dot" />
                    {profile.kofiHandle}
                  </span>
                </div>
              </div>

              <div className="support-card__perks">
                {s.perks.map((perk) => (
                  <span className="support-card__perk tag" key={perk}>
                    {perk}
                  </span>
                ))}
              </div>

              <div className="support-card__actions">
                <a
                  href={profile.kofi}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary support-card__btn"
                  data-cursor="hover"
                >
                  <Icon icon={SiKofi} /> {s.cta} <Icon icon={FiArrowUpRight} />
                </a>
                <span className="support-card__note mono">
                  <Icon icon={FiHeart} className="support-card__heart" /> {s.note}
                </span>
              </div>
            </div>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
